/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModalityTransactionDto } from './ModalityTransactionDto';
import {
    ModalityTransactionDtoFromJSON,
    ModalityTransactionDtoFromJSONTyped,
    ModalityTransactionDtoToJSON,
    ModalityTransactionDtoToJSONTyped,
} from './ModalityTransactionDto';

/**
 * 
 * @export
 * @interface ModalityTransactionPaginationDto
 */
export interface ModalityTransactionPaginationDto {
    /**
     * 
     * @type {number}
     * @memberof ModalityTransactionPaginationDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ModalityTransactionPaginationDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof ModalityTransactionPaginationDto
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof ModalityTransactionPaginationDto
     */
    nextPageToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModalityTransactionPaginationDto
     */
    hasMore?: boolean;
    /**
     * List of modality purchase transactions
     * @type {Array<ModalityTransactionDto>}
     * @memberof ModalityTransactionPaginationDto
     */
    data: Array<ModalityTransactionDto>;
}

/**
 * Check if a given object implements the ModalityTransactionPaginationDto interface.
 */
export function instanceOfModalityTransactionPaginationDto(value: object): value is ModalityTransactionPaginationDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ModalityTransactionPaginationDtoFromJSON(json: any): ModalityTransactionPaginationDto {
    return ModalityTransactionPaginationDtoFromJSONTyped(json, false);
}

export function ModalityTransactionPaginationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModalityTransactionPaginationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
        'nextPageToken': json['nextPageToken'] == null ? undefined : json['nextPageToken'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
        'data': ((json['data'] as Array<any>).map(ModalityTransactionDtoFromJSON)),
    };
}

export function ModalityTransactionPaginationDtoToJSON(json: any): ModalityTransactionPaginationDto {
    return ModalityTransactionPaginationDtoToJSONTyped(json, false);
}

export function ModalityTransactionPaginationDtoToJSONTyped(value?: ModalityTransactionPaginationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'nextPageToken': value['nextPageToken'],
        'hasMore': value['hasMore'],
        'data': ((value['data'] as Array<any>).map(ModalityTransactionDtoToJSON)),
    };
}

